import React, { Component, Fragment } from 'react';
import { Dialog, TableHead, DialogTitle, DialogContent, Typography, IconButton, Grid, Divider, Table, TableBody, TableRow, TableCell, Box, List, ListItem, ListItemAvatar, ListItemText, ListItemSecondaryAction } from '@material-ui/core';
import axios from 'axios';
import { isEmpty, size } from "lodash"
import PopUp from '../../../../commonModules/interface/PopUp';
import Currency from '../../../../commonModules/Currency';
import IncomeDetails from '../../Repayment/IncomeDetails';
import { CheckCircleOutlineRounded } from '@material-ui/icons';

class FactureComptaPopUp extends Component {
    state = { 
        photos: [],
        spending : {},
        income: {},
        exist: false,
        loading: false,
        error: null,
        lastFetchedID: null
    }
    componentDidMount = () => {
        this.updateStateFromProps();
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.spending !== this.props.spending ||
            prevProps.spendingID !== this.props.spendingID
        ) {
            this.updateStateFromProps();
        }
    }

    fetchSpending = async (spendingID) => {
        if (!spendingID || this.state.loading) {
            return;
        }

        // Éviter de refetch le même ID
        if (this.state.lastFetchedID === spendingID) {
            return;
        }

        this.setState({ loading: true, error: null, lastFetchedID: spendingID });

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            
            // Essayer d'abord comme spending
            const res = await axios.post("/stocks/compta/spendings/single", { spendingID }, config);
            
            if (res.data && res.data.spending_id) {
                this.setState({
                    spending: res.data,
                    income: {},
                    exist: true,
                    loading: false,
                    error: null
                });
                return;
            }

            // Si ce n'est pas un spending, essayer comme income
            const incomeRes = await axios.post("/money/get/income/info", { incomeID: spendingID }, config);
            
            if (incomeRes.data && incomeRes.data.income_amount !== 0) {
                const incomeData = { ...incomeRes.data, type: "income" };
                this.setState({
                    income: incomeData,
                    spending: {},
                    exist: true,
                    loading: false,
                    error: null
                });
                return;
            }

            // Aucune facture trouvée
            this.setState({
                spending: {},
                income: {},
                exist: false,
                loading: false,
                error: 'Facture introuvable'
            });
        } catch (error) {
            console.error('[FactureComptaPopUp] Erreur lors de la récupération de la facture:', error);
            this.setState({
                spending: {},
                income: {},
                exist: false,
                loading: false,
                error: error.message || 'Erreur lors de la récupération de la facture'
            });
        }
    }

    updateStateFromProps = () => {
        const { spending, spendingID } = this.props;
        
        // Réinitialiser lastFetchedID si spendingID a changé
        if (spendingID && this.state.lastFetchedID !== spendingID) {
            this.setState({ lastFetchedID: null });
        }
        
        if (spending && spending.spending_id) {
            if (this.state.spending?.spending_id === spending.spending_id) {
                return;
            }
            this.setState({
                spending,
                income: {},
                exist: true,
                loading: false,
                error: null
            });
            return;
        }

        if (spending && spending.type === "income") {
            if (this.state.income?.income_id === spending.income_id) {
                return;
            }
            this.setState({
                income: spending,
                spending: {},
                exist: true,
                loading: false,
                error: null
            });
            return;
        }

        // Si spendingID est présent mais spending est undefined, essayer de le récupérer via API
        if (spendingID && !spending) {
            this.fetchSpending(spendingID);
            return;
        }

        if (this.state.exist) {
            this.setState({
                spending: {},
                income: {},
                exist: false,
                loading: false
            });
        }
    }
    displayLabels = (labels) => {
        // const { spending } = this.state;
        
        let list = labels && labels.map( label => label.label_name)
        return list.join(", ")
    }

    render() {
        const { spending, exist, income, loading, error } = this.state
        const { spendingID, details } = this.props;
        
        return (
            <PopUp 
                maxWidth="md"
                close={this.props.handleClose} 
                title={`Facture n°${spendingID}`}
            >
            {/* <Dialog
                disableBackdropClick
                open={true}
                onClose={this.props.handleClose}
                aria-labelledby="form-dialog-title"
                maxWidth="lg"
                fullWidth
                scroll="paper"
            > */}
                {/* <DialogTitle >
                    <IconButton color="inherit" onClick={this.props.handleClose} aria-label="Close">
                        <ArrowBack /> 
                    </IconButton>
                    Facture n°{spending && spending.id}
                </DialogTitle> */}
                {exist ?
                <Fragment>
                    {!isEmpty(spending) &&
                    <Box>
                        <Typography variant="h6" style={{textAlign: "center"}}><Currency suffix=" FCFA" value={spending.spending_amountTTC} /></Typography>
                        <Divider />
                        <Grid container spacing={2} style={{marginTop: "20px"}}>
                            <Grid item xs={12} sm={6}>
                                
                                <Table className="table">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell> 
                                                <Typography variant="button">Montant HT:</Typography></TableCell>
                                            <TableCell><Currency suffix=" FCFA" value={spending.spending_amount} /></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> 
                                                <Typography variant="button">TVA:</Typography></TableCell>
                                            <TableCell><Currency suffix=" FCFA" value={spending.spending_TVA} /></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> 
                                                <Typography variant="button">Autres Taxes:</Typography></TableCell>
                                            <TableCell><Currency suffix=" FCFA" value={spending.spending_taxes} /></TableCell>
                                        </TableRow>                                    
                                        <TableRow>
                                            <TableCell> 
                                                <Typography variant="button">Montant TTC:</Typography></TableCell>
                                            <TableCell><Currency suffix=" FCFA" value={spending.spending_amountTTC || spending.spending_amount} /></TableCell>
                                        </TableRow>
                                        
                                        <TableRow>
                                            <TableCell> 
                                                <Typography variant="button">Payé le:</Typography>
                                            </TableCell>
                                            <TableCell>{new Date(spending.spending_date).toLocaleDateString("fr-FR")}
                                            </TableCell>
                                        </TableRow>
                                        
                                        <TableRow>
                                            <TableCell> 
                                                <Typography variant="button">Description:</Typography>
                                            </TableCell>
                                            <TableCell>{spending.spending_desc}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> 
                                                <Typography variant="button">Remarques:</Typography>
                                            </TableCell>
                                            <TableCell>{spending.spending_remarks}</TableCell>
                                        </TableRow>
                                        <Fragment>
                                            <TableRow>
                                                <TableCell> 
                                                    <Typography variant="button">Labels:</Typography>
                                                </TableCell>
                                                <TableCell>{spending.labels && this.displayLabels(spending.labels)}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell> 
                                                    <Typography variant="button">Total Payé:</Typography>
                                                </TableCell>
                                                <TableCell><Currency suffix=" FCFA" value={spending.spending_total_payed} /></TableCell>
                                            </TableRow>

                                        </Fragment>
                                    </TableBody>
                                </Table>
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                {!isEmpty(details) &&
                                        
                                    <ListItem>
                                        <ListItemAvatar>
                                            <CheckCircleOutlineRounded color="success" />
                                        </ListItemAvatar>
                                        <ListItemText 
                                            primary="Montant Lié"
                                            // secondary={new Date(PURCHASES[ID].date).toLocaleString('fr-FR')}
                                        />
                                        <ListItemSecondaryAction>
                                            <Currency suffix=" FCFA" value={details.amount} />
                                        </ListItemSecondaryAction>
                                        <hr />
                                    </ListItem>
                                }
                                {/* {!isEmpty(spending.spending_files) &&
                                    <Grid container spacing={3}>
                                        {spending.spending_files.map( (photo, index) => (
                                            <Fragment>
                                                {photo.filetype === "application/pdf" &&
                                                    <Grid key={photo.filename} item xs={12} >
                                                        <a href={`/stocks/compta/photos/${photo.filename}`} 
                                                            download={`fichier${index + 1}.${ extension(photo.filetype) || "pdf"}`}
                                                        >
                                                            <embed 
                                                                src={`/stocks/compta/photos/${photo.filename}`} 
                                                                width="100%" 
                                                                height="400px" 
                                                                title={`fichier${index + 1}`} 
                                                                type="application/pdf"
                                                            />
                                                        </a>
                                                    </Grid>
                                                }

                                                {photo.filetype !== "application/pdf" &&
                                                    <Grid key={photo.filename} item xs={6} >
                                                        <a href={`/stocks/compta/photos/${photo.filename}`} 
                                                            download={`fichier${index + 1}.${ extension(photo.filetype) || "jpg"}`}
                                                        >
                                                            <img 
                                                                src={`/stocks/compta/photos/${photo.filename}`} 
                                                                title={`fichier${index + 1}`} 
                                                                alt={`fichier${index + 1}`} 
                                                            />
                                                        </a>
                                                    </Grid>
                                                }
                                            </Fragment>                          
                                        )) }
                                    </Grid>
                                } */}
                            </Grid>
                        </Grid>
                    </Box>
                    }
                    {!isEmpty(income) &&
                        <IncomeDetails income={income} />
                    }
                </Fragment>
                :
                    <Box>
                        {loading ? (
                            <Typography variant="body1">
                                Chargement de la facture...
                            </Typography>
                        ) : (
                            <Fragment>
                                <Typography variant="body1" color="error">
                                    Facture introuvable
                                </Typography>
                                {error && (
                                    <Typography variant="body2" color="error" style={{ marginTop: 8 }}>
                                        {error}
                                    </Typography>
                                )}
                            </Fragment>
                        )}
                    </Box>
                }
            </PopUp>
        );
    }
}

export default FactureComptaPopUp;